var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.3334H16V18.3334H8V16.3334ZM8 12.3334H16V14.3334H8V12.3334ZM14 2.33337H6C4.9 2.33337 4 3.23337 4 4.33337V20.3334C4 21.4334 4.89 22.3334 5.99 22.3334H18C19.1 22.3334 20 21.4334 20 20.3334V8.33337L14 2.33337ZM18 20.3334H6V4.33337H13V9.33337H18V20.3334Z",
    fill: "#0BA9F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionBlueIcon);
export default __webpack_public_path__ + "static/media/description-blue-icon.cea9511e736c162659d98e2ba99d22ca.svg";
export { ForwardRef as ReactComponent };